<template>
  <!-- 敏感词库 -->
  <div class="sensitive-keywords-list">
    <div class="container">
      <!-- 搜索条件 -->
      <div class="between">
        <div class="sensitive-keywords-list-search">
          <el-form
            ref="sensitiveKeywordsFormRef"
            :inline="true"
            :model="sensitiveKeywordsForm"
            class="demo-form-inline"
          >
            <el-form-item label="敏感词">
              <el-input
                v-model="sensitiveKeywordsForm.keywords_name"
                clearable
                size="small"
              ></el-input>
            </el-form-item>

            <el-form-item label="敏感类型">
              <el-select
                v-model="sensitiveKeywordsForm.type"
                size="small"
                clearable
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.type"
                  :label="item.type_name"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" size="small" @click="searchBtn">
                查 询<i class="el-icon-search el-icon--right" />
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-button
          type="primary"
          size="medium"
          @click="addKeywords"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1802') : false
          "
        >
          新 建
        </el-button>
      </div>

      <!-- 表格 -->
      <div class="sensitive-keywords-list-table">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="{ background: '#F5F5F5' }"
          :data="sensitiveKeywordsData"
          style="width: 100%"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :label="item.label"
            :prop="item.prop"
            :width="item.width"
            :fixed="item.fixed"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'create_time'">
                {{ scope.row.create_time | dateFormat }}
              </div>

              <div v-else>
                {{
                  JSON.stringify(scope.row[item.prop]) === "null"
                    ? ""
                    : scope.row[item.prop]
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="medium"
                @click="delBtn(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1803') : false
                "
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
    <!-- 新增敏感词 -->
    <el-drawer
      title="新增敏感词"
      :visible.sync="drawer"
      direction="rtl"
      custom-class="custom-keywords-drawer"
    >
      <div class="add-keywords">
        <el-form
          ref="ruleForm"
          :model="addKeywordsForm"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item label="敏感类型" prop="type">
            <el-select
              v-model="addKeywordsForm.type"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.type"
                :label="item.type_name"
                :value="item.type"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="敏感词"
            prop="keywords_name"
            class="keywords-name"
          >
            <el-input
              v-model="addKeywordsForm.keywords_name"
              type="textarea"
              :rows="22"
              placeholder="请输入敏感词，以英文逗号隔开"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="drawer = false">取 消</el-button>
            <el-button type="primary" @click="confirmKeywordsBtn('ruleForm')"
              >确 定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination/index.vue";
import dayjs from "dayjs";
import template from "@/api/template";
export default {
  components: {
    Pagination,
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      sensitiveKeywordsForm: {
        keywords_name: "",
        type: "",
      },
      typeOptions: [],
      total: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      tableHeader: [
        {
          label: "敏感词",
          prop: "keywords_name",
          width: "auto",
          fixed: "left",
        },
        {
          label: "敏感类型",
          prop: "type_name",
          width: "auto",
          fixed: false,
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: "auto",
          fixed: false,
        },
      ],
      sensitiveKeywordsData: [],
      drawer: false,
      addKeywordsForm: {
        type: "",
        keywords_name: "",
      },
      rules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        keywords_name: [{ required: true, message: "请输入", trigger: "blur" }],
      },
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getsensitivekeywordstype();
    this.getList();
  },
  methods: {
    // 获取敏感词类型
    getsensitivekeywordstype() {
      template.getsensitivekeywordstype().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.typeOptions = data.list;
        }
      });
    },
    getList() {
      this.tableLoading = true;
      let params = Object.assign(
        {},
        this.pagination,
        this.sensitiveKeywordsForm
      );
      template.getSensitiveKeywordsList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.total = data.total;
          this.sensitiveKeywordsData = data.list;
          this.tableLoading = false;
        }
      });
    },
    // 查询
    searchBtn() {
      this.pagination.page = 1;
      this.getList();
    },
    // 删除
    delBtn(row) {
      let { keywords_id } = row;

      this.$confirm("确认删除该数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const loading = this.$loading();
          template
            .deleteSensitiveKeywords({ keywords_id })
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("删除成功");
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    // 新增敏感词
    addKeywords() {
      this.addKeywordsForm = {
        type: "",
        keywords_name: "",
      };
      this.$nextTick(() => {
        this.$refs["ruleForm"] ? this.$refs["ruleForm"].clearValidate() : "";
      });
      this.drawer = true;
    },
    confirmKeywordsBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.addKeywordsForm);
          template.addSensitiveKeywords(params).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success("添加成功");
              this.getList();
              this.drawer = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.sensitive-keywords-list {
  .sensitive-keywords-list-search {
    display: flex;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .sensitive-keywords-list-table {
    border: 1px solid #c9cdd6;
    // .el-table {
    // min-height: 476px;
    // }
  }
}
</style>
<style lang="scss">
.custom-keywords-drawer {
  .el-drawer__header {
    text-align: left;
    font-weight: bold;
    color: #000;
    font-size: 18px;
    padding: 20px 10px;
    border-bottom: 1px solid #dcdfe6;
  }
  .add-keywords {
    padding: 0 10px;
    .keywords-name {
      .el-form-item__content {
        height: auto;
      }
    }
  }
}
</style>
